export default __webpack_public_path__ + "static/media/why.d4d04b10.png";